module.exports = __webpack_public_path__ + "static/media/shuttlecock.51f095d4.svg";